import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_ORGANIZATION = gql`
  mutation($data: CreateCompanyInput!) {
    createCompany(data: $data) {
      message
    }
  }
`;

export const UPDATE_ORGANIZATION = gql`
  mutation($where: CompanyWhereUniqueInput!, $data: UpdateCompanyInput!) {
    updateCompany(where: $where, data: $data) {
      message
    }
  }
`;

export const DELETE_ORGANIZATION = gql`
  mutation($where: CompanyWhereUniqueInput!) {
    deleteCompany(where: $where) {
      message
    }
  }
`;

export const UPDATE_ORGANIZATION_STATUS = gql`
  mutation($data: UpdateCompanyInput!, $where: CompanyWhereUniqueInput!) {
    updateCompany(data: $data, where: $where) {
      message
    }
  }
`;

export const CREATE_ORGANIZATION_CONFIG = gql`
  mutation($data: CreateCompanyConfigInput!) {
    createCompanyConfig(data: $data) {
      message
    }
  }
`;

export const UPDATE_ORGANIZATION_CONFIG = gql`
  mutation(
    $data: UpdateCompanyConfigInput!
    $where: CompanyConfigWhereUniqueInput!
  ) {
    updateCompanyConfig(data: $data, where: $where) {
      message
    }
  }
`;

export const UPDATE_UI_LABEL = gql`
  mutation($data: UpdateUILabelInput!, $where: UILabelWhereUniqueInput!) {
    updateUILabel(data: $data, where: $where) {
      message
    }
  }
`;

export const REFETCH_UI_LABELS = gql`
  mutation($data: CreateCloudFrontCacheInvalidationInput!) {
    createCloudFrontCacheInvalidation(data: $data) {
      message
    }
  }
`;

export const CREATE_EMAIL_CONFIG = gql`
  mutation($data: CreateCompanyConfigInput!) {
    createCompanyConfig(data: $data) {
      message
    }
  }
`;

export const UPDATE_EMAIL_CONFIG = gql`
  mutation(
    $data: UpdateCompanyConfigInput!
    $where: CompanyConfigWhereUniqueInput!
  ) {
    updateCompanyConfig(data: $data, where: $where) {
      message
    }
  }
`;

export const EXPORT_COMPANY_CONFIG = gql`
  mutation($where: ExportCompanyConfigsWhere!) {
    exportCompanyConfigs(where: $where) {
      message
    }
  }
`;

export const IMPORT_COMPANY_CONFIG = gql`
  mutation($input: ImportCompanyConfigsInput!) {
    importCompanyConfigs(input: $input) {
      message
    }
  }
`;

export const CREATE_BLOG = gql`
  mutation CreateBlog($data: CreateBlogInput!) {
    createBlog(data: $data) {
      message
      data {
        id
        companyId
        link
        title
        description
        image
        icon
        order
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_BLOG = gql`
  mutation UpdateBlog($data: UpdateBlogInput!, $where: BlogWhereUniqueInput!) {
    updateBlog(data: $data, where: $where) {
      message
      data {
        id
        companyId
        link
        title
        description
        image
        icon
        order
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_BLOG = gql`
  mutation DeleteBlog($where: BlogWhereUniqueInput!) {
    deleteBlog(where: $where) {
      message
    }
  }
`;

export const UPDATE_BLOG_ORDER = gql`
  mutation UpdateBlogOrder(
    $where: BlogWhereUniqueInput!
    $data: UpdateBlogOrderInput!
  ) {
    updateBlogOrder(where: $where, data: $data) {
      message
      data {
        id
        companyId
        link
        title
        description
        image
        icon
        order
        createdAt
        updatedAt
      }
    }
  }
`;
